import { type FC, type PropsWithChildren } from 'react';

export const BoldTerm: FC<PropsWithChildren<Record<never, never>>> = ({
  children,
}) => <span className="font-semibold">&ldquo;{children}&rdquo;</span>;
